import actionTypes from "../../actions/actionTypes";

const initialState = {
  classOrSeriesData: [],
  deleteMandatedClassData: null,
  manageUsersCount: 0,
  manageSubgroupsCount: 0,
};

const groupManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.groupManagement.GET_CLASSES_OR_SERIES:
      return {
        ...state,
        classOrSeriesData: payload,
      };
    case actionTypes.adminTypes.groupManagement.DELETE_MANADATED_CLASS:
      return {
        ...state,
        deleteMandatedClassData: payload,
      };
    case actionTypes.adminTypes.groupManagement.MANAGE_USERS_COUNT:
      return {
        ...state,
        manageUsersCount: payload,
      };
    case actionTypes.adminTypes.groupManagement.MANAGE_SUBGROUPS_COUNT:
      return {
        ...state,
        manageSubgroupsCount: payload,
      };
    default:
      return state;
  }
};

export default groupManagementReducer;
